/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputPositionStockStatisticsItem
 */
export interface OutputPositionStockStatisticsItem {
    /**
     * 
     * @type {string}
     * @memberof OutputPositionStockStatisticsItem
     */
    cameraType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputPositionStockStatisticsItem
     */
    connectionType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    currentBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    expendedLast30Days?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    expendedLast7Days?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    expendedToday?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    expendedYesterday?: number;
    /**
     * ТТХ номенклатури (null там, де не стосується типу засобу)
     * @type {string}
     * @memberof OutputPositionStockStatisticsItem
     */
    missionType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    opticDistanceKm?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    stockItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputPositionStockStatisticsItem
     */
    stockItemName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputPositionStockStatisticsItem
     */
    stockItemType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputPositionStockStatisticsItem
     */
    warheadType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    weightKg?: number;
}

/**
 * Check if a given object implements the OutputPositionStockStatisticsItem interface.
 */
export function instanceOfOutputPositionStockStatisticsItem(value: object): boolean {
    return true;
}

export function OutputPositionStockStatisticsItemFromJSON(json: any): OutputPositionStockStatisticsItem {
    return OutputPositionStockStatisticsItemFromJSONTyped(json, false);
}

export function OutputPositionStockStatisticsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputPositionStockStatisticsItem {
    if (json == null) {
        return json;
    }
    return {
        
        'cameraType': json['cameraType'] == null ? undefined : json['cameraType'],
        'connectionType': json['connectionType'] == null ? undefined : json['connectionType'],
        'currentBalance': json['currentBalance'] == null ? undefined : json['currentBalance'],
        'expendedLast30Days': json['expendedLast30Days'] == null ? undefined : json['expendedLast30Days'],
        'expendedLast7Days': json['expendedLast7Days'] == null ? undefined : json['expendedLast7Days'],
        'expendedToday': json['expendedToday'] == null ? undefined : json['expendedToday'],
        'expendedYesterday': json['expendedYesterday'] == null ? undefined : json['expendedYesterday'],
        'missionType': json['missionType'] == null ? undefined : json['missionType'],
        'opticDistanceKm': json['opticDistanceKm'] == null ? undefined : json['opticDistanceKm'],
        'stockItemId': json['stockItemId'] == null ? undefined : json['stockItemId'],
        'stockItemName': json['stockItemName'] == null ? undefined : json['stockItemName'],
        'stockItemType': json['stockItemType'] == null ? undefined : json['stockItemType'],
        'warheadType': json['warheadType'] == null ? undefined : json['warheadType'],
        'weightKg': json['weightKg'] == null ? undefined : json['weightKg'],
    };
}

export function OutputPositionStockStatisticsItemToJSON(value?: OutputPositionStockStatisticsItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cameraType': value['cameraType'],
        'connectionType': value['connectionType'],
        'currentBalance': value['currentBalance'],
        'expendedLast30Days': value['expendedLast30Days'],
        'expendedLast7Days': value['expendedLast7Days'],
        'expendedToday': value['expendedToday'],
        'expendedYesterday': value['expendedYesterday'],
        'missionType': value['missionType'],
        'opticDistanceKm': value['opticDistanceKm'],
        'stockItemId': value['stockItemId'],
        'stockItemName': value['stockItemName'],
        'stockItemType': value['stockItemType'],
        'warheadType': value['warheadType'],
        'weightKg': value['weightKg'],
    };
}

